import React from 'react';

import { IonAccordionGroup } from '@ionic/react';

import { DEFAULT_ACCORDION } from './constants';
import { IAccordionGroup } from './interfaces';

export const AccordionGroup = ({
  value = DEFAULT_ACCORDION,
  multiple = true,
  children,
}: IAccordionGroup) => {
  return (
    <IonAccordionGroup value={value} multiple={multiple}>
      {children}
    </IonAccordionGroup>
  );
};
